import { Box } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import { TextSemiBold } from 'UiKit/typography';
import useIsHelpHostVisible from 'View/host-stream/hooks/useIsHelpHostVisible';

import useGetTabOptions from 'View/host-stream/helpers/useGetTabOptions';
import { useBriefLiveWidgetState } from 'View/host-stream/components/brief-live-widget/state';

import styles from './styles.module.css';

const BriefLiveWidgetTab = () => {
  const { state, updateState } = useBriefLiveWidgetState();
  const { selectedTab } = state;

  const isHelpHostVisible = useIsHelpHostVisible();

  const topDistance = isHelpHostVisible ? '92px' : '0px';

  const handleTabChange = (selectedTab) => {
    updateState({ selectedTab });
  };

  const getClassname = (isActive) => {
    return {
      tabContainer: isActive ? styles['tab__box--active'] : styles['tab__box--inactive'],
      text: isActive ? styles['tab__text--active'] : styles['tab__text--inactive'],
    };
  };

  return (
    <Box className={styles['tab__container']} top={topDistance}>
      <Iteration
        items={useGetTabOptions()}
        render={(item) => {
          const isActive = selectedTab === item.type;
          const { tabContainer, text } = getClassname(isActive);
          return (
            <Box className={tabContainer} onClick={() => handleTabChange(item.type)}>
              <TextSemiBold className={text}>{item.label}</TextSemiBold>
            </Box>
          );
        }}
      />
    </Box>
  );
};

export default BriefLiveWidgetTab;
